<template>
  <div class="light-apply">
    <div class="light-section-title">申請人</div>
    <inputField
      id="name"
      label="姓名"
      :disabled="true"
      class="ligth-item-margin"
      :value="applyInfo.applyName"
    />
    <inputField
      id="phone"
      label="手機號碼/聯絡電話"
      :disabled="true"
      class="ligth-item-margin"
      :value="applyInfo.applyPhone"
    />

    <div class="line" />

    <personInfo
      v-for="(item, index) in displayInfo.prayerList"
      :key="index"
      :prayerInfo="item"
      :prayerIndex="index"
      :totalCount="displayInfo.prayerList.length"
      :lightInfo="lightInfo"
      :disabled="true"
      :isRecord="false"
    >
    </personInfo>

    <div class="line" />

    <div class="light-section-title">費用總計</div>
    <inputField
      id="light-fee"
      label="費用總計"
      :disabled="true"
      class="ligth-item-margin"
      :value="calAmount()"
    />

    <div class="line" />

    <div v-if="givewayInfo.givewayName" class="light-section-title">贈品</div>
    <div v-if="givewayInfo.givewayName" style="margin: 10px 0 0 0">
      {{ givewayInfo.givewayName }}
    </div>
    <div v-if="givewayInfo.givewayName" style="margin: 10px 0 0 0">
      {{
        `贈品寄送地址：${
          givewayInfo.givewayAddress.county &&
          givewayInfo.givewayAddress.town &&
          givewayInfo.givewayAddress.detail
            ? givewayInfo.givewayAddress.county +
              givewayInfo.givewayAddress.town +
              givewayInfo.givewayAddress.detail
            : '現場領取'
        }`
      }}
    </div>
    <div v-if="givewayInfo.givewayName" class="line" />

    <div class="light-section-title">付款方式</div>
    <dropdownBtn
      v-model="payWay"
      label="選擇付款方式"
      :options="payOptions"
      class="ligth-item-margin"
    ></dropdownBtn>
    <div>
      請在20分鐘內完成付款，若付款失敗，該筆訂單將被取消，若有需要請重新下單
    </div>
    <div class="light-footer-steps">
      <div
        class="temple-button-text light-footer-previous"
        @click="previousClick"
      >
        上一步
      </div>
      <div class="temple-button-text light-footer-next" @click="payClick">
        付款
      </div>
    </div>
  </div>
</template>

<script scoped>
import store from 'Store/store';
import personInfo from 'Pages/ServiceModule/ServiceLight/ServiceLightPersonInfo.vue';
import inputField from 'Components/inputField/inputField.vue';
import dropdownBtn from 'Components/dropdown/dropdown.vue';
import formater from 'Core/format.js';

export default {
  name: 'ServiceLightStep4',
  components: { personInfo, inputField, dropdownBtn },
  data() {
    return {
      payWay: '0',
      payOptions: [{ text: 'LINE Pay', value: '0' }],
      info: {},
    };
  },
  beforeMount() {
    this.info = this.applyInfo;
  },
  mounted() {},

  methods: {
    calAmount() {
      let result = this.displayInfo.price + this.displayInfo.fare;

      return `${formater.thousandComma(result)}元`;
    },
    previousClick() {
      this.$emit('previousStep');
    },
    nextClick() {
      this.validateFormat() && this.validateLogic() && this.goNextStep();
    },
    payClick() {
      let paymentInfo = {};
      Object.assign(paymentInfo, this.displayInfo);
      paymentInfo.paymentType = Number(this.payWay);
      this.$emit('pay', paymentInfo);
    },
  },
  computed: {
    displayInfo() {
      return this.applyInfo;
    },
    applyInfo() {
      return store.state.main.lightApplyInfo;
    },
    lightInfo() {
      var lightInfoList = [];
      lightInfoList = store.state.main.onlineStatus.lightInfo.lightList.map(
        (light) => {
          return {
            text: light.name,
            value: light.type,
            price: light.price,
            remainingAmount: light.remainingAmount,
            disabled: light.remainingAmount <= 0 ? true : false,
          };
        }
      );
      return lightInfoList;
    },
    givewayInfo() {
      return store.state.main.lightApplyInfo.prayerList[0];
    },
  },
};
</script>

<style>
.light-apply {
  margin: 0px 5px 0px 5px;
}
.light-footer-steps {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.light-footer-previous {
  margin-right: 15px;
}

.light-footer-next {
  margin-left: 15px;
}

.line {
  margin-top: 30px;
  width: 100%;
  border-top: 1px solid;
  border-color: black;
}

.light-section-title {
  margin-top: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #b18147;
}
.ligth-item-margin {
  margin-top: 10px;
}

@media (min-width: 768px) {
  .light-footer-steps {
    margin-top: 150px;
  }
}
</style>
